import * as actions from './actions';
import reducers from './reducer';

export const News = { actions, reducers };
export { NewsState } from './reducer';
